import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuthStore } from "../store";
import { api } from "../lib";

export function usePageVisitTracking() {
  const location = useLocation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) return;
    const url = location.pathname + location.search;
    api.post("/audit/page-visit", { url }).catch(() => {
      // fire-and-forget — swallow errors silently
    });
  }, [location.pathname, location.search, isAuthenticated]);
}
